unit TauEdit;

interface

uses
  System.SysUtils, System.Classes, System.StrUtils, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Storage,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Imaging.GIFImg, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,
  XData.Web.Client, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.WebCtrls, VCL.TMSFNCPageControl, VCL.TMSFNCTabSet,
  VCL.TMSFNCListBox, WEBLib.Lists, WEBLib.SignatureCapture, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WebBasis2, VCL.TMSFNCPanel, VCL.TMSFNCButton;

[async] function DoTauEdit( aID_Tau, aID_Tour : Integer ) : TModalResult; async;

type
  TfrmTauEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    lbBeladung: TLabel;
    lbEntladung: TLabel;
    [async]
    pgContr: TTMSFNCPageControl;
    tabDaten: TTMSFNCPageControlContainer;
    mDaten: TMemo;
    tabDoku: TTMSFNCPageControlContainer;
    ImgContr: TImageControl;
    lbDokumentPos: TLabel;
    fpFilePicker: TFilePicker;
    cbxDokumente: TComboBox;
    btnDokumentDel: TTMSFNCToolBarButton;
    edtTauRef: TLabel;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavPrev: TTMSFNCToolBarButton;
    edtBeladung: TLabel;
    edtEntladung: TLabel;
    tabEmpfang: TTMSFNCPageControlContainer;
    sigCapt: TSignatureCapture;
    btnSignaturSpeichern: TTMSFNCToolBarButton;
    mInfoSign: TMemo;
    btnOK: TTMSFNCToolBarButton;
    btnAbbrechen: TTMSFNCToolBarButton;
    btnAkt: TTMSFNCToolBarButton;
    btnDownload: TTMSFNCToolBarButton;
    btnTauStart: TTMSFNCToolBarButton;
    btnTauStop: TTMSFNCToolBarButton;
    lbBarcode: TListBox;
    btnBarcodeDel: TTMSFNCToolBarButton;
    WebLabel1: TLabel;
    btnBarcodeIns: TTMSFNCToolBarButton;
    procedure fpFilePickerChange(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
     //
    [async]  procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnDokumentDelClick(Sender: TObject); async;
    [async] procedure fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string); async;
    [async] procedure Daten_Laden; async;
    [async] procedure Dokumente_Laden; async;
    [async] procedure Bild_Anzeigen; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure btnSignaturSpeichernClick(Sender: TObject); async;
    [async] procedure btnAktClick(Sender: TObject); async;
    [async] procedure btnPdfClick(Sender: TObject); async;
    [async] procedure TauMeldungClick(Sender: TObject); async;
    [async] procedure btnBarcodeInsClick(Sender: TObject); async;
    [async] procedure btnBarcodeDelClick(Sender: TObject); async;
     //
    procedure DoDokumentNav(Sender: TObject);
    procedure pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
    procedure cbxDokumenteChange(Sender: TObject);
    procedure ImgContrDblClick(Sender: TObject);
    procedure btnOKClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);


  private
    iID_AktDok : Integer;
    iID_Tour   : Integer;
    sDokTyp : String;
    function Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
    procedure Form_Anpassen;
    procedure Opt_Speichern;
    procedure Opt_Laden;


  public
    iID_Tau : Integer;
  protected procedure LoadDFMValues; override; end;

var frmTauEdit: TfrmTauEdit;

const cFormTauEdit = 'TAUEDIT_';

implementation

{$R *.dfm}

uses UnitMain, Konstanten, GlobalWeb , SpediFucsDatenmodul, ShowGrafik, TourEdit, GetBarcode;


//================================================================================================//

function DoTauEdit( aID_Tau, aID_Tour : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;

  frmTauEdit := TfrmTauEdit.Create(application);
  frmTauEdit.Popup   := True;
  //frmTauEdit.Border  := fbDialogSizeable;
  frmTauEdit.iID_Sprache := frmMainForm.iID_Sprache;
  frmTauEdit.iID_Tau  := aID_Tau;
  frmTauEdit.iID_Tour := aID_Tour;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmTauEdit, frmTauEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmTauEdit.Resize;

  Try
    await( TModalResult, frmTauEdit.Execute);  // excute form and wait for close

    Result := frmTauEdit.ModalResult;

    //Änderungen speichern
    //If Result = mrOK then  // frmTauEdit.Daten_Speichern;
    //Showmessage(frmTauEdit.mDaten.Text);
//
  Finally
    frmTauEdit.Free;
  End;


  If aID_Tour > 0 then   DoTourEdit( aID_Tour);

  frmMainForm.mMainMenu.Enabled := True;

end;

//====================================================================================================================//

procedure TfrmTauEdit.Opt_Speichern;
begin

  TLocalStorage.SetValue( cFormTauEdit+'PAGE', IntToStr(pgContr.ActivePageIndex) );

end;

//====================================================================================================================//

procedure TfrmTauEdit.Opt_Laden;
begin
  pgContr.ActivePageIndex := StrToIntDef( TLocalStorage.GetValue( cFormTauEdit+'PAGE' )  ,0);

end;

//====================================================================================================================//

procedure TfrmTauEdit.btnOKClick(Sender: TObject);
begin
  inherited;

  If Sender = btnOK then ModalResult := mrOK
  Else ModalResult := mrCancel;

  Close;

end;

//====================================================================================================================//

procedure TfrmTauEdit.btnPdfClick(Sender: TObject);
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sDatei : String;
    aGuiObj : TCoreGuiObj;
    iID : Integer;
    am : TMemoryStream;
    mr : TModalResult;
begin
  inherited;

  If cbxDokumente.ItemIndex = -1 then Exit;
  If cbxDokumente.Items.Count = 0 then Exit;

  aGuiObj :=  TCoreGuiObj( cbxDokumente.Items.Objects[ cbxDokumente.ItemIndex ]);
  iID := aGuiObj.ID;


  If not WaitMessage.Showing then WaitMessage.Show;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
  Response := await( ClientConn.RawInvokeAsync('ISystemService.Get_DokumentDatei', [iID] ));
  ClientConn.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);
  //sDaten := await( Crypt( sDaten ) );

  WaitMessage.Hide;

  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Dokument konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      sDatei := cbxDokumente.Text;
      am := TMemoryStream.Create;
        TTMSFNCUtils.LoadStreamFromBase64( sDaten, am );
      am.SaveToFile(sDatei);
      am.Free;
    End;

end;

//====================================================================================================================//

procedure TfrmTauEdit.Dokumente_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp : String;
    aSL, aSL_Daten : TStringList;
    i, iAnz, iAnzDok  : Integer;
    aGuiObj :  TCoreGuiObj;
    aArray : TArray<string>;
begin


  If not WaitMessage.Showing then WaitMessage.Show;


  sSQL :='01:SELECT ID_DOKUMENT, BEZEICHNUNG, INS_AM, ID_DOK_TYP FROM DOKUMENT D '
           +' WHERE ID_DOK_BEZ=(SELECT ID_DOK_BEZ FROM TAU WHERE ID_TAU='+IntToStr(self.iID_Tau)+');' ;

  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  cbxDokumente.Items.clear;

  For i := 2 to aSL.Count -1 Do
    Begin
       sTmp := aSL[i];
       aArray := sTmp.Split([';']);
       If sDokTyp<>'' then
         If sDokTyp <> aArray[3] then Continue;
       aGuiObj :=  TCoreGuiObj.Create;
       aGuiObj.ID := StrToIntDef( aArray[0],0 );
       aGuiObj.Bezeichnung := aArray[1];
       cbxDokumente.Items.AddObject( aArray[1], aGuiObj );
    End;

  iAnzDok := cbxDokumente.Items.Count;
  cbxDokumente.Enabled   := (iAnzDok>0);
  btnDokumentDel.Enabled := (iAnzDok>0);

  lbDokumentPos.Caption := '0/0';

  If iAnzDok > 0 then
    Begin
      cbxDokumente.ItemIndex :=  (iAnzDok-1);
      lbDokumentPos.Caption := IntToStr( cbxDokumente.ItemIndex+1 ) +'/' +IntToStr( cbxDokumente.Items.Count );
    End;

  aSL.Free;
  aSL_Daten.Free;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmTauEdit.btnAktClick(Sender: TObject);
begin
  await(  Dokumente_Laden );
  await(  Bild_Anzeigen );
end;

//====================================================================================================================//

procedure TfrmTauEdit.btnDokumentDelClick(Sender: TObject);
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    Blob: JSValue;
    sImgBase64, sDaten : String;
    iID, iErg : Integer;
    res: TModalResult;
begin


  If cbxDokumente.ItemIndex = -1 then Exit;
  If cbxDokumente.Items.Count = 0 then Exit;

  res := await(TModalResult, MessageDlgAsync('Dokument löschen ?', mtConfirmation, [mbYes, mbNo]));
  if res <> mrYes then Exit;


  If not WaitMessage.Showing then WaitMessage.Show;

  aGuiObj :=  TCoreGuiObj( cbxDokumente.Items.Objects[ cbxDokumente.ItemIndex ]);
  iID := aGuiObj.ID;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
  Response := await( ClientConn.RawInvokeAsync('ISystemService.Del_DokumentDatei', [iID] ));
  ClientConn.Free;

  cbxDokumente.Items.Delete(cbxDokumente.ItemIndex);
  cbxDokumente.ItemIndex :=  cbxDokumente.Items.Count-1;

  ImgContr.Clear;

  await( Bild_Anzeigen );

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmTauEdit.btnBarcodeDelClick(Sender: TObject);
var sCode, sSQL : String;
    iErg : Integer;
    aModalResult : TModalResult;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
begin
  inherited;

  If lbBarcode.Items.Count = 0 then Exit;

  If lbBarcode.ItemIndex=-1 then
    Begin
     await(TModalResult, MessageDlgAsync('Es ist kein Barcode markiert', mtInformation, [mbOK]));
     Exit;
    End;

  sCode := lbBarcode.Items[lbBarcode.ItemIndex];

  sSQL := 'DELETE FROM TAU_BARCODE WHERE ID_TAU=' +IntToStr(self.iID_Tau)  +' AND BARCODE='+cH+sCode+cH;

  sSQL := await(  Crypt( sSQL ) );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.ExecSQL', [ sSQL ] ));
  ClientConn.Free;

  iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

  If iErg=0 then  lbBarcode.DeleteSelected;



end;

//====================================================================================================================//

procedure TfrmTauEdit.btnBarcodeInsClick(Sender: TObject);
var sCode, sSQL : String;
    iErg : Integer;
    aModalResult : TModalResult;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
begin
  inherited;

  sCode := '';

  If (frmMainForm.IstHttps=False) and (frmMainForm.IstLocalHost=False) then
    Begin
      await(TModalResult, MessageDlgAsync('Der Zugriff auf die Kamera ist nur unter HTTPS möglich...', mtInformation, [mbOK]));
      Exit;
    End;

  aModalResult := await( TModalResult, Get_Barcode( sCode ) );


  If aModalResult <> mrOK then Exit;

  If sCode='' then Exit;

  sSQL := 'INSERT INTO TAU_BARCODE ( ID_TAU, BARCODE, SCANN_AM, SCANN_USER ) VALUES ('
          +IntToStr(self.iID_Tau)+', '
          +cH+sCode+cH+', '
          +' Now , '  +cH+ frmMainForm.User_Account+cH      +')';

  sSQL := await(  Crypt( sSQL ) );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.ExecSQL', [ sSQL ] ));
  ClientConn.Free;

  iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

  If iErg=0 then lbBarcode.Items.Add( sCode );

end;

//====================================================================================================================//

procedure TfrmTauEdit.btnSignaturSpeichernClick(Sender: TObject);
var sDateiName, sBase64 : String;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    mr : TModalResult;
begin
  inherited;


  sDateiName := 'Sign_'+IntToStr(self.iID_Tau)+'_'+FormatDateTime('yymmdd_hhnnss', Now) + '.PNG';


  sBase64 :=  sigCapt.GetAsBase64Image;

  sBase64 := Trim( Copy( sBase64, 23, Length(sBase64)) );



  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_Dokument', [ sBase64, sDateiName, c_Tau, iID_Tau  ] ));

  ClientConn.Free;


  mr := await(TModalResult, MessageDlgAsync('Die Signatur wurde gespeichert', mtConfirmation, [mbOK]));

  //If mr = mrOK then  btnSignaturSpeichern.Enabled := False;


end;

//====================================================================================================================//

procedure TfrmTauEdit.cbxDokumenteChange(Sender: TObject);
begin
  inherited;
  Bild_Anzeigen;
end;

//====================================================================================================================//

procedure TfrmTauEdit.Daten_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sInfo, sKopfZeile: String;
    aSL, aSL_Daten : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz, iAnzDok, iTop : Integer;
    aGuiObj :  TCoreGuiObj;
    aArray : TArray<string>;
    li: TListItem;
begin

  console.log('TfrmTauEdit.Daten_Laden - Start '+IntToStr(self.iID_Tau) );

  If not WaitMessage.Showing then WaitMessage.Show;


       //             0         1            2             3              4             5                6
  sSQL := '01:SELECT T.ID_TAU, T.REF_NR, T.KND_AUFTR_NR, T.BELADUNG_AM, T.ENTLADUNG_AM, T.FRACHT_FREMD, T.PAL_TAUSCH, '
         +'   '
         +' (SELECT RNGREF FROM LFTRNG R WHERE T.ID_LFTRNG=R.ID_LFTRNG ) as LFT_RNG, '   //  7
         +' (SELECT ADR_TEXT  FROM GET_ADRESSE( BELADUNG_ID_ADR)) AS BELADESTELLE, '     //  8
         +' (SELECT ADR_TEXT  FROM GET_ADRESSE( ENTLADUNG_ID_ADR)) AS ENTLADESTELLE, '   //  9
         +' (SELECT ADR_NAME1 FROM GET_ADRESSE( BELADUNG_ID_ADR))  AS BELADE_NAME, '      // 10
         +' (SELECT ADR_NAME1 FROM GET_ADRESSE( ENTLADUNG_ID_ADR)) AS ENTLADE_NAME, '    //  11
         +' (SELECT COUNT(ID_DOKUMENT) FROM DOKUMENT D WHERE D.ID_DOK_BEZ=T.ID_DOK_BEZ) AS ANZ_DOK, '
         +' (SELECT FIRST 1 KENNZEICHEN FROM  TOUR_POS TP, TOUR R, FAHRZEUG F WHERE TP.ID_TAU=T.ID_TAU  AND TP.ID_TOUR=R.ID_TOUR AND R.ID_FAHRZEUG1=F.ID_FAHRZEUG) as FZG1, '
         +' (SELECT FIRST 1 KENNZEICHEN FROM  TOUR_POS TP, TOUR R, FAHRZEUG F WHERE TP.ID_TAU=T.ID_TAU  AND TP.ID_TOUR=R.ID_TOUR AND R.ID_FAHRZEUG2=F.ID_FAHRZEUG) as FZG2, '
         +' (SELECT NAME1 FROM ADRESSE A WHERE K.ID_ADRESSE=A.ID_ADRESSE) as Kunde, '   // 15
         +' (SELECT BEZEICHNUNG FROM UEBENE1 U1 WHERE U1.ID_UEBENE1=T.ID_UEBENE1) as UEBENE1, '    // 16
         +' (SELECT TOURNAME FROM TOUR_NAME N WHERE N.ID_TOUR_NAME=T.ID_TOUR_NAME ) as TOURNAME, '  // 17
         +' (SELECT NAME1 FROM LIEFERANT L, ADRESSE A  WHERE L.ID_ADRESSE=A.ID_ADRESSE AND T.ID_LFT_FREMD=L.ID_LIEFERANT) as LFT_FREMD, '  //18
             //     19             20          21         22         23        24     25
         +'  T.ID_LFT_FREMD,  T.ID_KUNDE, T.ID_DOK_BEZ, T.GEWICHT, T.VOLUMEN, T.LM, T.INFO  '
         + ' FROM TAU T, KUNDE K WHERE T.ID_KUNDE=K.ID_KUNDE AND ID_TAU='+IntToStr(self.iID_Tau)
         +';'

         +'02:SELECT ID_DOKUMENT, BEZEICHNUNG, INS_AM, ID_DOK_TYP FROM DOKUMENT D WHERE ID_DOK_BEZ=(SELECT ID_DOK_BEZ FROM TAU WHERE ID_TAU='+IntToStr(self.iID_Tau)+');'


         +'03:SELECT WERT FROM OPTIONEN WHERE BEREICH='+cH+'OPT_ONLINE'+cH +' AND FELD='+cH+'DOKTYP_TAU_LFT'+cH+';'

         +'04:'+ Get_SQL_Ladestellen(self.iID_Tau) +';'

         +'05:SELECT P.ANZAHL, P.BEZEICHNUNG, P.GEWICHT, T.REF_NR, T.THM_BEZ, T.SORT_NR '
           +' FROM TAU_PCK P LEFT JOIN THM T ON T.ID_THM=P.ID_THM  WHERE P.ID_TAU_PCK=P.ID_TAU_PCK '
           +' AND ID_TAU ='+IntToStr(self.iID_Tau)+' ORDER BY T.SORT_NR ' +';'

         +'06:SELECT BARCODE FROM TAU_BARCODE WHERE ID_TAU='+IntToStr(self.iID_Tau) +';'  ;



  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  mDaten.Clear;
  mInfoSign.Clear;

  // Transportauftrag ---------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  sTmp := aSL[2];
  aArray := sTmp.Split([';']);

  edtTauRef.Caption := aArray[1];
  edtBeladung.Caption  := Copy( aArray[3],1,16)+'  '+aArray[8];
  edtEntladung.Caption := Copy( aArray[4],1,16)+'  '+aArray[9];

  mDaten.Lines.Add( Transl(80,'Kundenauftrag')+': '+ aArray[2] );
  mDaten.Lines.Add( Transl(90,'Gewicht')+ ' : '+ aArray[22] +' kg'  );
  mDaten.Lines.Add( Transl(100,'Volumen')+': '+ aArray[23] +' m3'  );
  mDaten.Lines.Add( Transl(110,'Lademeter')+ ': '+ aArray[24] +' m2'  );
  mDaten.Lines.Add( '' );

  sInfo := aArray[25];
  sInfo := ReplaceStr( sInfo, '##', chr(13)+chr(10) );
  If sInfo <>'' then mDaten.Lines.Add(sInfo);

  mDaten.Lines.Add( StringOfChar('-', 40) );

  // Option Dokumententyp -----------------------------------------------------
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '03');
  sTmp := aSL[2];
  aArray := sTmp.Split([';']);
  sDokTyp := aArray[0];

  // Ladestellen----------------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '04');

  For i := 2 to aSL.Count -1 Do
    Begin
       sTmp := aSL[i];
       aArray := sTmp.Split([';']);

       sTmp := '';
       If aArray[2] ='B' then sTmp := Transl(30,'Beladung')+': ';
       If aArray[2] ='E' then sTmp := Transl(40,'Entladung')+': ';
       mDaten.Lines.Add( sTmp +  aArray[0] +' ['+aArray[12]+']' );  // Datum und Zeit

       mDaten.Lines.Add( aArray[3] +' ' + aArray[4] ); // Name1 und Name2
       mDaten.Lines.Add( aArray[6] );  // Strasse
       mDaten.Lines.Add( aArray[7] +' ' + aArray[8] ); // PLZ und ORT
       mDaten.Lines.Add( aArray[11] );  // Land
       mDaten.Lines.Add( Transl(150,'Ansprechpartner')+': '+ aArray[13] +' '+ aArray[15]  );
       If aArray[10] <>'' then  mDaten.Lines.Add( aArray[10] );  // Ladegut
       If aArray[9]  <>'' then  mDaten.Lines.Add( aArray[9] );   // LadeInfo
       mDaten.Lines.Add( StringOfChar('-', 40) );
    End;


  // Packstücke ----------------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '05');
  If iAnz>2 then
    Begin
       sTmp := Transl(130, 'Packstücke' );
       mDaten.Lines.Add('');
       mDaten.Lines.Add(sTmp+':');
       //sigCapt.Canvas.TextOut(5,0,'Packstücke:');
       mInfoSign.Lines.Add(sTmp+':');
    End;

  iTop := Abs( sigCapt.Canvas.Font.Height );
  For i := 2 to aSL.Count -1 Do
    Begin
       sTmp := aSL[i];
       aArray := sTmp.Split([';']);
       sTmp := aArray[0]+'x '+ aArray[4] +' > ' + aArray[2] +' kg';

       mDaten.Lines.Add( sTmp );
       mInfoSign.Lines.Add( sTmp );
    End;


  // Barcodes ----------------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '06');
  If iAnz>2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
           sDaten := aSL[i];
           lbBarcode.Items.Add( GetFeldWert( sFelder, sDaten, 'BARCODE' ));
        End;
    End;





  // Dokumente -----------------------------------------------------------------
  await( Dokumente_Laden );
  If pgContr.ActivePageIndex = 1 then  await(  Bild_Anzeigen );

  mDaten.Lines.Add('');
  mDaten.Lines.Add('');

  aSL.Free;
  aSL_Daten.Free;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

  console.log('TfrmTauEdit.Daten_Laden - Ende '+IntToStr(self.iID_Tau) );

end;

//====================================================================================================================//

procedure TfrmTauEdit.DoDokumentNav(Sender: TObject);
var iIdx, iAnz : Integer;
begin

  If cbxDokumente.Items.Count=0 then Exit;

  iIdx := cbxDokumente.ItemIndex;
  Inc(iIdx);
  iAnz := cbxDokumente.Items.Count;

  If Sender = btnNavNext then
    Begin
      If iIdx = iAnz then Exit;
      cbxDokumente.ItemIndex := cbxDokumente.ItemIndex +1;
    End
  Else
    Begin
      If iIdx = 1 then Exit;
      cbxDokumente.ItemIndex := cbxDokumente.ItemIndex -1;
    End;

  Bild_Anzeigen;

end;

//====================================================================================================================//

procedure TfrmTauEdit.fpFilePickerChange(Sender: TObject);
begin
  fpFilePicker.Files[0].GetFileAsBase64;
end;

//====================================================================================================================//

procedure TfrmTauEdit.fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string);
var sBase64, sDateiName, sExt : String;
    aFile : TFile;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
begin

  aFile :=  fpFilePicker.Files[AFileIndex];
  sExt  := UpperCase( ExtractFileext(aFile.Name) );

  If (sExt='.PNG') or (sExt='.JPG') or (sExt='.JPEG') or (sExt='.BMP')  then
    Begin
      sBase64 := c_ImgVorsatz + ABase64;
      ImgContr.url := sBase64;
    End;


  sDateiName := aFile.Name;
  sDateiName := 'D'+IntToStr(self.iID_Tau)+'_'+FormatDateTime('yymmdd_hhnnss', Now)   + sExt ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_Dokument', [ ABase64, sDateiName, c_Tau, iID_Tau  ] ));
  ClientConn.Free;

  TFile(fpFilePicker.Files[AFileIndex]).Name := sDateiName;



  await( Daten_Laden );

end;

//====================================================================================================================//

procedure TfrmTauEdit.Bild_Anzeigen;
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    Blob: JSValue;
    sImgBase64, sDaten, sExt : String;
    iID : Integer;
    mr : TModalResult;
begin

  If cbxDokumente.Items.Count=0 then lbDokumentPos.Caption := '0/0';

  If cbxDokumente.ItemIndex = -1 then Exit;
  If cbxDokumente.Items.Count = 0 then Exit;

  aGuiObj :=  TCoreGuiObj( cbxDokumente.Items.Objects[ cbxDokumente.ItemIndex ]);
  iID := aGuiObj.ID;

  // Bild schon geladen ?
  If iID = iID_AktDok then Exit;

  // Grafik-Format ?
  sExt := UpperCase( ExtractFileExt( aGuiObj.Bezeichnung ) );
  If (sExt<>'.JPG') and (sExt<>'.JPEG') and (sExt<>'.PNG') and (sExt<>'.BMP') and (sExt<>'.GIF') then Exit;


  If not WaitMessage.Showing then WaitMessage.Show;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
  Response :=  await( ClientConn.RawInvokeAsync('ISystemService.Get_DokumentDatei', [iID] ) );
  ClientConn.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);
  //sDaten := await( Crypt( sDaten ) );

  WaitMessage.Hide;

  Console.Log('>>> ['+sDaten+']');
  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Dokument konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      sImgBase64 := c_ImgVorsatz + sDaten;
      ImgContr.URL := sImgBase64;
    End;

  iID_AktDok := iID;

  lbDokumentPos.Caption := IntToStr( cbxDokumente.ItemIndex+1 ) +'/' +IntToStr( cbxDokumente.Items.Count );

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmTauEdit.WebButton1Click(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );
end;

//====================================================================================================================//

procedure TfrmTauEdit.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Opt_Speichern;
  inherited;

end;

//====================================================================================================================//

procedure TfrmTauEdit.WebFormCreate(Sender: TObject);
begin
  inherited;
  Opt_Laden;
end;

//====================================================================================================================//

procedure TfrmTauEdit.WebFormResize(Sender: TObject);
begin

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmTauEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;



  // Komponenten
   iZielBreite := Trunc( self.Width * 0.95 );
   If iZielBreite > 500 then iZielBreite := 500;

   cbxDokumente.Width := iZielBreite - cbxDokumente.Left;

   fpFilePicker.Width := iZielBreite - fpFilePicker.Left;
   edtBeladung.Width  := iZielBreite - edtBeladung.Left;
   edtEntladung.Width := iZielBreite - edtEntladung.Left;

   sigCapt.Width := iZielBreite - sigCapt.Left;
   btnSignaturSpeichern.Width := iZielBreite - btnSignaturSpeichern.Left;
   mInfoSign.Width := iZielBreite - mInfoSign.Left;

   Console.Log('>> Form_Anpassen');
   lbDokumentPos.Left := cbxDokumente.Left + cbxDokumente.Width - lbDokumentPos.Width;

end;

//====================================================================================================================//

procedure TfrmTauEdit.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  iID_AktDok := 0;

  Sprach_Daten_Laden('TAUEDIT', frmMainForm.iID_Sprache );

  Daten_Laden;

  Form_Anpassen;


end;

//====================================================================================================================//

function TfrmTauEdit.Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
begin


//  Result := 'SELECT WERT FROM OPTIONEN';
//  exit;

  Result :=

  'SELECT T.DATUM, T.POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, T.INFO AS LADE_INFO, T.LADEGUT, '
  +' (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, T.ZEIT AS ZEIT_TXT,  '
  +'  '+cH+cH+' as ANSP_NAME, '  +'  '+cH+cH+' as ANSP_ZUNAME, '
  +'  '+cH+cH+' as ANSP_TEL, '+cH+cH + ' as ANSP_ANREDE '
  +' FROM TAU_ADR T, ADRESSE A WHERE T.ID_ADRESSE = A.ID_ADRESSE '
  +' AND T.ID_TAU ='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.BELADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.ENTLADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )


  +' ORDER BY 1 '; // T.DATUM, T.POS ' ;


end;

procedure TfrmTauEdit.ImgContrDblClick(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );


end;

//====================================================================================================================//

procedure TfrmTauEdit.pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
begin

  If aCurrentPageIndex = 1 then  Bild_Anzeigen;
  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmTauEdit.TauMeldungClick(Sender: TObject);
var iID , iTab, iID_MldPunkt  : Integer;
    ClientConn: TXDataWebClient;
    Response: TXDataClientResponse;
    aParam : TParam;
begin

  If Sender = btnTauStart then
       iID_MldPunkt := -100
  Else iID_MldPunkt := -80;

  aParam := TParam.Create;
  aParam.Integer1 := iID_MldPunkt;  // Start/Stop
  aParam.ID_Tau := self.iID_Tau;
  aParam.ID_Mab := StrToIntDef( frmMainForm.BenutzerMaNr, 0);
  aParam.Datum1 := Now;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_TauMeldung', [ aParam  ] ));
  ClientConn.Free;

  If Sender= btnTauStart then
    Begin
      mDaten.Lines.Add( FormatDateTime('dd.mm.yyyy hh:nn', aParam.Datum1) + ' - Start');
      btnTauStart.Enabled := False;
    End;

  If Sender= btnTauStop then
    Begin
      mDaten.Lines.Add( FormatDateTime('dd.mm.yyyy hh:nn', aParam.Datum1) + ' - Stop');
      btnTauStop.Enabled := False;
    End;

 aParam.Free;


end;

//====================================================================================================================//

//procedure TfrmTauEdit.SprachDaten_Laden( aID_Sprache : Integer =0 );
//var Response: TXDataClientResponse;
//    ClientConn: TXDataWebClient;
//    Blob: JSValue;
//    sDaten, sSQL, sTmp : String;
//    aSL : TStringList;
//    aStream : TStream;
//    i : Integer;
//    aArray : TArray<string>;
//begin
//
//  If not WaitMessage.Showing then WaitMessage.Show;
//
//  ClientConn := TXDataWebClient.Create(nil);
//  ClientConn.Connection := frmMainForm.XDataConn;
//    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['TAUEDIT',aID_Sprache] ) );
//    Blob := Response.Result;
//    asm sDaten = await Blob.text(); end;
//  ClientConn.Free;
//
//  aSL := TStringList.Create;
//  aSL.Text := await( Crypt( sDaten)) ;
//
//  console.Log(  aSL.Text  );
//
//  tabSprachDaten.Close;
//  tabSprachDaten.Open;
//
//  If aSL.Count > 2 then
//    For i := 2 to aSL.Count -1 Do
//        Begin
//         sTmp := aSL[i];
//          aArray := sTmp.Split([';']);
//          tabSprachDaten.Append;
//          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
//          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
//          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
//          console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
//
//          tabSprachDaten.Post;
//        End;
//
//  aSL.Free;
//
//  Form_Uebersetzen;
//
//  WaitMessage.Hide;
//
//end;

//====================================================================================================================//

procedure TfrmTauEdit.Form_Uebersetzen;
begin

  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmTauEdit -> NICHT OFFFEN');
     Exit;
    End;

  //console.Log( 'Form_Uebersetzen in TfrmTauEdit');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 20, [] ) then lbNummer.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 30, [] ) then lbBeladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 40, [] ) then lbEntladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  If tabSprachDaten.Locate('NUMMER', 50, [] ) then pgContr.Pages[0].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 60, [] ) then pgContr.Pages[1].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 70, [] ) then pgContr.Pages[2].Text := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 120, [] ) then btnAbbrechen.Text := tabSprachDatenBEGRIFF_UEB.AsString;

  If tabSprachDaten.Locate('NUMMER', 140, [] ) then  btnSignaturSpeichern.Text := tabSprachDatenBEGRIFF_UEB.AsString;



 self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmTauEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  lbBeladung := TLabel.Create(Self);
  lbEntladung := TLabel.Create(Self);
  edtTauRef := TLabel.Create(Self);
  edtBeladung := TLabel.Create(Self);
  edtEntladung := TLabel.Create(Self);
  btnOK := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  pgContr := TTMSFNCPageControl.Create(Self);
  tabEmpfang := TTMSFNCPageControlContainer.Create(Self);
  sigCapt := TSignatureCapture.Create(Self);
  btnSignaturSpeichern := TTMSFNCToolBarButton.Create(Self);
  mInfoSign := TMemo.Create(Self);
  tabDoku := TTMSFNCPageControlContainer.Create(Self);
  ImgContr := TImageControl.Create(Self);
  lbDokumentPos := TLabel.Create(Self);
  fpFilePicker := TFilePicker.Create(Self);
  cbxDokumente := TComboBox.Create(Self);
  btnDokumentDel := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnAkt := TTMSFNCToolBarButton.Create(Self);
  btnDownload := TTMSFNCToolBarButton.Create(Self);
  tabDaten := TTMSFNCPageControlContainer.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  mDaten := TMemo.Create(Self);
  btnTauStart := TTMSFNCToolBarButton.Create(Self);
  btnTauStop := TTMSFNCToolBarButton.Create(Self);
  lbBarcode := TListBox.Create(Self);
  btnBarcodeDel := TTMSFNCToolBarButton.Create(Self);
  btnBarcodeIns := TTMSFNCToolBarButton.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  lbBeladung.BeforeLoadDFMValues;
  lbEntladung.BeforeLoadDFMValues;
  edtTauRef.BeforeLoadDFMValues;
  edtBeladung.BeforeLoadDFMValues;
  edtEntladung.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  pgContr.BeforeLoadDFMValues;
  tabEmpfang.BeforeLoadDFMValues;
  sigCapt.BeforeLoadDFMValues;
  btnSignaturSpeichern.BeforeLoadDFMValues;
  mInfoSign.BeforeLoadDFMValues;
  tabDoku.BeforeLoadDFMValues;
  ImgContr.BeforeLoadDFMValues;
  lbDokumentPos.BeforeLoadDFMValues;
  fpFilePicker.BeforeLoadDFMValues;
  cbxDokumente.BeforeLoadDFMValues;
  btnDokumentDel.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnAkt.BeforeLoadDFMValues;
  btnDownload.BeforeLoadDFMValues;
  tabDaten.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  mDaten.BeforeLoadDFMValues;
  btnTauStart.BeforeLoadDFMValues;
  btnTauStop.BeforeLoadDFMValues;
  lbBarcode.BeforeLoadDFMValues;
  btnBarcodeDel.BeforeLoadDFMValues;
  btnBarcodeIns.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 580;
    Height := 567;
    Color := 16776441;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 580;
    WebPanel1.Height := 119;
    WebPanel1.Align := alTop;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 157;
    lbTau.Top := 5;
    lbTau.Width := 140;
    lbTau.Height := 18;
    lbTau.Caption := 'Transportauftrag';
    lbTau.Font.Charset := DEFAULT_CHARSET;
    lbTau.Font.Color := clBlack;
    lbTau.Font.Height := -15;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    lbBeladung.SetParentComponent(WebPanel1);
    lbBeladung.Name := 'lbBeladung';
    lbBeladung.Left := 16;
    lbBeladung.Top := 55;
    lbBeladung.Width := 59;
    lbBeladung.Height := 16;
    lbBeladung.Caption := 'Beladung';
    lbBeladung.HeightPercent := 100.000000000000000000;
    lbBeladung.WidthPercent := 100.000000000000000000;
    lbEntladung.SetParentComponent(WebPanel1);
    lbEntladung.Name := 'lbEntladung';
    lbEntladung.Left := 16;
    lbEntladung.Top := 82;
    lbEntladung.Width := 65;
    lbEntladung.Height := 16;
    lbEntladung.Caption := 'Entladung';
    lbEntladung.HeightPercent := 100.000000000000000000;
    lbEntladung.WidthPercent := 100.000000000000000000;
    edtTauRef.SetParentComponent(WebPanel1);
    edtTauRef.Name := 'edtTauRef';
    edtTauRef.Left := 157;
    edtTauRef.Top := 26;
    edtTauRef.Width := 87;
    edtTauRef.Height := 18;
    edtTauRef.Caption := 'T0000000';
    edtTauRef.Font.Charset := ANSI_CHARSET;
    edtTauRef.Font.Color := clWindowText;
    edtTauRef.Font.Height := -15;
    edtTauRef.Font.Name := 'Verdana';
    edtTauRef.Font.Style := [fsBold];
    edtTauRef.HeightPercent := 100.000000000000000000;
    edtTauRef.ParentFont := False;
    edtTauRef.WidthPercent := 100.000000000000000000;
    edtBeladung.SetParentComponent(WebPanel1);
    edtBeladung.Name := 'edtBeladung';
    edtBeladung.Left := 97;
    edtBeladung.Top := 55;
    edtBeladung.Width := 71;
    edtBeladung.Height := 16;
    edtBeladung.Caption := 'T0000000';
    edtBeladung.Font.Charset := ANSI_CHARSET;
    edtBeladung.Font.Color := clWindowText;
    edtBeladung.Font.Height := -13;
    edtBeladung.Font.Name := 'Verdana';
    edtBeladung.Font.Style := [fsBold];
    edtBeladung.HeightPercent := 100.000000000000000000;
    edtBeladung.ParentFont := False;
    edtBeladung.WidthPercent := 100.000000000000000000;
    edtEntladung.SetParentComponent(WebPanel1);
    edtEntladung.Name := 'edtEntladung';
    edtEntladung.Left := 97;
    edtEntladung.Top := 82;
    edtEntladung.Width := 71;
    edtEntladung.Height := 16;
    edtEntladung.Caption := 'T0000000';
    edtEntladung.Font.Charset := ANSI_CHARSET;
    edtEntladung.Font.Color := clWindowText;
    edtEntladung.Font.Height := -13;
    edtEntladung.Font.Name := 'Verdana';
    edtEntladung.Font.Style := [fsBold];
    edtEntladung.HeightPercent := 100.000000000000000000;
    edtEntladung.ParentFont := False;
    edtEntladung.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(WebPanel1);
    btnOK.Name := 'btnOK';
    btnOK.Left := 72;
    btnOK.Top := 5;
    btnOK.Width := 65;
    btnOK.Height := 44;
    btnOK.Cursor := crHandPoint;
    btnOK.ParentDoubleBuffered := False;
    btnOK.DoubleBuffered := True;
    btnOK.Font.Charset := ANSI_CHARSET;
    btnOK.Font.Color := clWindowText;
    btnOK.Font.Height := -13;
    btnOK.Font.Name := 'Verdana';
    btnOK.Font.Style := [];
    btnOK.ParentColor := True;
    btnOK.TabOrder := 0;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnOK.Text := '';
    btnOK.TextVisible := False;
    btnOK.Bitmaps.Clear;
    with btnOK.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnOK.BitmapVisible := True;
    btnOK.BitmapContainer := BitmapCont;
    btnOK.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 5;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 1;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    pgContr.SetParentComponent(Self);
    pgContr.Name := 'pgContr';
    pgContr.Left := 0;
    pgContr.Top := 119;
    pgContr.Width := 580;
    pgContr.Height := 448;
    pgContr.Align := alClient;
    pgContr.ParentDoubleBuffered := False;
    pgContr.Color := clBtnFace;
    pgContr.DoubleBuffered := True;
    pgContr.TabOrder := 1;
    pgContr.Fill.Kind := gfkNone;
    pgContr.Fill.Color := 16776441;
    pgContr.Stroke.Kind := gskNone;
    pgContr.TabAppearance.Font.Charset := ANSI_CHARSET;
    pgContr.TabAppearance.Font.Color := clWindowText;
    pgContr.TabAppearance.Font.Height := -13;
    pgContr.TabAppearance.Font.Name := 'Verdana';
    pgContr.TabAppearance.Font.Style := [];
    pgContr.TabAppearance.Fill.Color := clWhite;
    pgContr.TabAppearance.ActiveFill.Color := 16639703;
    pgContr.TabAppearance.DownFill.Color := 15776936;
    pgContr.TabAppearance.DownStroke.Color := 15702829;
    pgContr.TabAppearance.HoverFill.Color := 16380654;
    pgContr.TabAppearance.HoverStroke.Color := 15702829;
    pgContr.TabAppearance.TextSpacing := 0.000000000000000000;
    pgContr.TabAppearance.ActiveTextColor := 4539717;
    pgContr.TabAppearance.HoverTextColor := 8026746;
    pgContr.TabAppearance.DownTextColor := 4539717;
    pgContr.TabAppearance.ShowFocus := False;
    pgContr.TabAppearance.CloseStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseDownStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseHoverStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    pgContr.TabAppearance.BadgeFont.Color := clDarkred;
    pgContr.TabAppearance.BadgeFont.Height := -11;
    pgContr.TabAppearance.BadgeFont.Name := 'Segoe UI';
    pgContr.TabAppearance.BadgeFont.Style := [fsBold];
    pgContr.ButtonAppearance.CloseIcon.LoadFromFile('TauEdit.pgContr.ButtonAppearance.CloseIcon.svg');
    pgContr.ButtonAppearance.InsertIcon.LoadFromFile('TauEdit.pgContr.ButtonAppearance.InsertIcon.svg');
    pgContr.ButtonAppearance.TabListIcon.LoadFromFile('TauEdit.pgContr.ButtonAppearance.TabListIcon.svg');
    pgContr.ButtonAppearance.ScrollNextIcon.LoadFromFile('TauEdit.pgContr.ButtonAppearance.ScrollNextIcon.svg');
    pgContr.ButtonAppearance.ScrollPreviousIcon.LoadFromFile('TauEdit.pgContr.ButtonAppearance.ScrollPreviousIcon.svg');
    pgContr.BitmapContainer := BitmapCont;
    pgContr.Options.TabListButton := True;
    pgContr.TabSize.Mode := tsmFixedSize;
    pgContr.TabSize.Width := 120.000000000000000000;
    pgContr.TabSize.Height := 40.000000000000000000;
    pgContr.TabSize.Margins.Left := 8.000000000000000000;
    pgContr.TabSize.Margins.Top := 8.000000000000000000;
    pgContr.TabSize.Margins.Right := 8.000000000000000000;
    pgContr.TabSize.Margins.Bottom := 8.000000000000000000;
    pgContr.Pages.Clear;
    with pgContr.Pages.Add do
    begin
      Text := 'Daten';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    with pgContr.Pages.Add do
    begin
      Text := 'Dokumente';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    with pgContr.Pages.Add do
    begin
      Text := 'Empfang';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    SetEvent(pgContr, Self, 'OnChangePage', 'pgContrChangePage');
    tabEmpfang.SetParentComponent(pgContr);
    tabEmpfang.Name := 'tabEmpfang';
    tabEmpfang.AlignWithMargins := True;
    tabEmpfang.Left := 0;
    tabEmpfang.Top := 47;
    tabEmpfang.Width := 580;
    tabEmpfang.Height := 401;
    tabEmpfang.Margins.Left := 0;
    tabEmpfang.Margins.Top := 47;
    tabEmpfang.Margins.Right := 0;
    tabEmpfang.Margins.Bottom := 0;
    tabEmpfang.Align := alClient;
    tabEmpfang.ParentDoubleBuffered := False;
    tabEmpfang.Color := 16776441;
    tabEmpfang.DoubleBuffered := True;
    tabEmpfang.TabStop := False;
    tabEmpfang.TabOrder := 2;
    tabEmpfang.Visible := False;
    tabEmpfang.Fill.Color := 16776441;
    tabEmpfang.PageIndex := 2;
    tabEmpfang.IsActive := False;
    sigCapt.SetParentComponent(tabEmpfang);
    sigCapt.Name := 'sigCapt';
    sigCapt.Left := 9;
    sigCapt.Top := 80;
    sigCapt.Width := 500;
    sigCapt.Height := 229;
    sigCapt.Cursor := crHandPoint;
    sigCapt.TabOrder := 0;
    sigCapt.TextPosition.Line.Color := clGray;
    sigCapt.Text := 'hier unterschreiben';
    sigCapt.Pen.Width := 2;
    btnSignaturSpeichern.SetParentComponent(tabEmpfang);
    btnSignaturSpeichern.Name := 'btnSignaturSpeichern';
    btnSignaturSpeichern.Left := 9;
    btnSignaturSpeichern.Top := 331;
    btnSignaturSpeichern.Width := 500;
    btnSignaturSpeichern.Height := 40;
    btnSignaturSpeichern.Cursor := crHandPoint;
    btnSignaturSpeichern.ParentDoubleBuffered := False;
    btnSignaturSpeichern.DoubleBuffered := True;
    btnSignaturSpeichern.Font.Charset := ANSI_CHARSET;
    btnSignaturSpeichern.Font.Color := clWindowText;
    btnSignaturSpeichern.Font.Height := -13;
    btnSignaturSpeichern.Font.Name := 'Verdana';
    btnSignaturSpeichern.Font.Style := [];
    btnSignaturSpeichern.ParentColor := True;
    btnSignaturSpeichern.TabOrder := 1;
    SetEvent(btnSignaturSpeichern, Self, 'OnClick', 'btnSignaturSpeichernClick');
    btnSignaturSpeichern.Text := 'Speichern';
    btnSignaturSpeichern.ControlIndex := 0;
    mInfoSign.SetParentComponent(tabEmpfang);
    mInfoSign.Name := 'mInfoSign';
    mInfoSign.Left := 9;
    mInfoSign.Top := 8;
    mInfoSign.Width := 500;
    mInfoSign.Height := 66;
    mInfoSign.HeightPercent := 100.000000000000000000;
    mInfoSign.ReadOnly := True;
    mInfoSign.ScrollBars := ssVertical;
    mInfoSign.SelLength := 0;
    mInfoSign.SelStart := 0;
    mInfoSign.WidthPercent := 100.000000000000000000;
    tabDoku.SetParentComponent(pgContr);
    tabDoku.Name := 'tabDoku';
    tabDoku.AlignWithMargins := True;
    tabDoku.Left := 0;
    tabDoku.Top := 47;
    tabDoku.Width := 580;
    tabDoku.Height := 401;
    tabDoku.Margins.Left := 0;
    tabDoku.Margins.Top := 47;
    tabDoku.Margins.Right := 0;
    tabDoku.Margins.Bottom := 0;
    tabDoku.Align := alClient;
    tabDoku.ParentDoubleBuffered := False;
    tabDoku.Color := 16776441;
    tabDoku.DoubleBuffered := True;
    tabDoku.TabStop := False;
    tabDoku.TabOrder := 0;
    tabDoku.Visible := False;
    tabDoku.Fill.Color := 16776441;
    tabDoku.PageIndex := 1;
    tabDoku.IsActive := False;
    ImgContr.SetParentComponent(tabDoku);
    ImgContr.Name := 'ImgContr';
    ImgContr.Left := 3;
    ImgContr.Top := 138;
    ImgContr.Width := 574;
    ImgContr.Height := 260;
    ImgContr.WidthStyle := ssAuto;
    ImgContr.HeightPercent := 100.000000000000000000;
    ImgContr.WidthPercent := 100.000000000000000000;
    ImgContr.Anchors := [akLeft,akTop,akRight,akBottom];
    ImgContr.ChildOrder := 1;
    SetEvent(ImgContr, Self, 'OnDblClick', 'ImgContrDblClick');
    lbDokumentPos.SetParentComponent(tabDoku);
    lbDokumentPos.Name := 'lbDokumentPos';
    lbDokumentPos.Left := 427;
    lbDokumentPos.Top := 35;
    lbDokumentPos.Width := 22;
    lbDokumentPos.Height := 16;
    lbDokumentPos.Caption := '0/0';
    lbDokumentPos.Color := 16776441;
    lbDokumentPos.HeightPercent := 100.000000000000000000;
    lbDokumentPos.WidthPercent := 100.000000000000000000;
    fpFilePicker.SetParentComponent(tabDoku);
    fpFilePicker.Name := 'fpFilePicker';
    fpFilePicker.Left := 14;
    fpFilePicker.Top := 96;
    fpFilePicker.Width := 497;
    fpFilePicker.Height := 36;
    fpFilePicker.Accept := 'image/*';
    fpFilePicker.ChildOrder := 1;
    SetEvent(fpFilePicker, Self, 'OnChange', 'fpFilePickerChange');
    SetEvent(fpFilePicker, Self, 'OnGetFileAsBase64', 'fpFilePickerGetFileAsBase64');
    cbxDokumente.SetParentComponent(tabDoku);
    cbxDokumente.Name := 'cbxDokumente';
    cbxDokumente.Left := 14;
    cbxDokumente.Top := 57;
    cbxDokumente.Width := 497;
    cbxDokumente.Height := 24;
    cbxDokumente.Cursor := crHandPoint;
    cbxDokumente.HeightStyle := ssAuto;
    cbxDokumente.HeightPercent := 100.000000000000000000;
    cbxDokumente.WidthPercent := 100.000000000000000000;
    SetEvent(cbxDokumente, Self, 'OnChange', 'cbxDokumenteChange');
    cbxDokumente.ItemIndex := -1;
    btnDokumentDel.SetParentComponent(tabDoku);
    btnDokumentDel.Name := 'btnDokumentDel';
    btnDokumentDel.Left := 226;
    btnDokumentDel.Top := 7;
    btnDokumentDel.Width := 65;
    btnDokumentDel.Height := 44;
    btnDokumentDel.Cursor := crHandPoint;
    btnDokumentDel.ParentDoubleBuffered := False;
    btnDokumentDel.DoubleBuffered := True;
    btnDokumentDel.Font.Charset := ANSI_CHARSET;
    btnDokumentDel.Font.Color := clWindowText;
    btnDokumentDel.Font.Height := -13;
    btnDokumentDel.Font.Name := 'Verdana';
    btnDokumentDel.Font.Style := [];
    btnDokumentDel.ParentColor := True;
    btnDokumentDel.TabOrder := 2;
    SetEvent(btnDokumentDel, Self, 'OnClick', 'btnDokumentDelClick');
    btnDokumentDel.Text := '';
    btnDokumentDel.TextVisible := False;
    btnDokumentDel.Bitmaps.Clear;
    with btnDokumentDel.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnDokumentDel.BitmapVisible := True;
    btnDokumentDel.BitmapContainer := BitmapCont;
    btnDokumentDel.ControlIndex := 0;
    btnNavNext.SetParentComponent(tabDoku);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 81;
    btnNavNext.Top := 7;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 3;
    SetEvent(btnNavNext, Self, 'OnClick', 'DoDokumentNav');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavPrev.SetParentComponent(tabDoku);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 14;
    btnNavPrev.Top := 7;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 4;
    SetEvent(btnNavPrev, Self, 'OnClick', 'DoDokumentNav');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnAkt.SetParentComponent(tabDoku);
    btnAkt.Name := 'btnAkt';
    btnAkt.Left := 154;
    btnAkt.Top := 7;
    btnAkt.Width := 65;
    btnAkt.Height := 44;
    btnAkt.Cursor := crHandPoint;
    btnAkt.ParentDoubleBuffered := False;
    btnAkt.DoubleBuffered := True;
    btnAkt.Font.Charset := ANSI_CHARSET;
    btnAkt.Font.Color := clWindowText;
    btnAkt.Font.Height := -13;
    btnAkt.Font.Name := 'Verdana';
    btnAkt.Font.Style := [];
    btnAkt.ParentColor := True;
    btnAkt.TabOrder := 5;
    SetEvent(btnAkt, Self, 'OnClick', 'btnAktClick');
    btnAkt.Text := '';
    btnAkt.TextVisible := False;
    btnAkt.Bitmaps.Clear;
    with btnAkt.Bitmaps.Add do
    begin
      BitmapName := 'AKT';
    end;
    btnAkt.BitmapVisible := True;
    btnAkt.BitmapContainer := BitmapCont;
    btnAkt.ControlIndex := 0;
    btnDownload.SetParentComponent(tabDoku);
    btnDownload.Name := 'btnDownload';
    btnDownload.Left := 299;
    btnDownload.Top := 7;
    btnDownload.Width := 65;
    btnDownload.Height := 44;
    btnDownload.Cursor := crHandPoint;
    btnDownload.ParentDoubleBuffered := False;
    btnDownload.DoubleBuffered := True;
    btnDownload.Font.Charset := ANSI_CHARSET;
    btnDownload.Font.Color := clWindowText;
    btnDownload.Font.Height := -13;
    btnDownload.Font.Name := 'Verdana';
    btnDownload.Font.Style := [];
    btnDownload.ParentColor := True;
    btnDownload.TabOrder := 6;
    SetEvent(btnDownload, Self, 'OnClick', 'btnPdfClick');
    btnDownload.Text := '';
    btnDownload.TextVisible := False;
    btnDownload.Bitmaps.Clear;
    with btnDownload.Bitmaps.Add do
    begin
      BitmapName := 'DOWNLOAD';
    end;
    btnDownload.BitmapVisible := True;
    btnDownload.BitmapContainer := BitmapCont;
    btnDownload.ControlIndex := 0;
    tabDaten.SetParentComponent(pgContr);
    tabDaten.Name := 'tabDaten';
    tabDaten.AlignWithMargins := True;
    tabDaten.Left := 0;
    tabDaten.Top := 47;
    tabDaten.Width := 580;
    tabDaten.Height := 401;
    tabDaten.Margins.Left := 0;
    tabDaten.Margins.Top := 47;
    tabDaten.Margins.Right := 0;
    tabDaten.Margins.Bottom := 0;
    tabDaten.Align := alClient;
    tabDaten.ParentDoubleBuffered := False;
    tabDaten.Color := 16776441;
    tabDaten.DoubleBuffered := True;
    tabDaten.TabStop := False;
    tabDaten.TabOrder := 1;
    tabDaten.Fill.Color := 16776441;
    tabDaten.PageIndex := 0;
    tabDaten.IsActive := True;
    WebLabel1.SetParentComponent(tabDaten);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 194;
    WebLabel1.Top := 2;
    WebLabel1.Width := 63;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Barcode'#39's';
    WebLabel1.Color := 16776441;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    mDaten.SetParentComponent(tabDaten);
    mDaten.Name := 'mDaten';
    mDaten.Left := 3;
    mDaten.Top := 87;
    mDaten.Width := 566;
    mDaten.Height := 311;
    mDaten.Anchors := [akLeft,akTop,akRight,akBottom];
    mDaten.Font.Charset := ANSI_CHARSET;
    mDaten.Font.Color := clWindowText;
    mDaten.Font.Height := -13;
    mDaten.Font.Name := 'Verdana';
    mDaten.Font.Style := [];
    mDaten.HeightPercent := 100.000000000000000000;
    mDaten.ParentFont := False;
    mDaten.ReadOnly := True;
    mDaten.SelLength := 0;
    mDaten.SelStart := 0;
    mDaten.WidthPercent := 100.000000000000000000;
    btnTauStart.SetParentComponent(tabDaten);
    btnTauStart.Name := 'btnTauStart';
    btnTauStart.Left := 8;
    btnTauStart.Top := 20;
    btnTauStart.Width := 73;
    btnTauStart.Height := 61;
    btnTauStart.Cursor := crHandPoint;
    btnTauStart.ParentDoubleBuffered := False;
    btnTauStart.DoubleBuffered := True;
    btnTauStart.Font.Charset := ANSI_CHARSET;
    btnTauStart.Font.Color := clWindowText;
    btnTauStart.Font.Height := -13;
    btnTauStart.Font.Name := 'Verdana';
    btnTauStart.Font.Style := [];
    btnTauStart.ParentColor := True;
    btnTauStart.TabOrder := 1;
    SetEvent(btnTauStart, Self, 'OnClick', 'TauMeldungClick');
    btnTauStart.Text := 'Start';
    btnTauStart.BitmapContainer := BitmapCont;
    btnTauStart.ControlIndex := 0;
    btnTauStop.SetParentComponent(tabDaten);
    btnTauStop.Name := 'btnTauStop';
    btnTauStop.Left := 88;
    btnTauStop.Top := 20;
    btnTauStop.Width := 73;
    btnTauStop.Height := 61;
    btnTauStop.Cursor := crHandPoint;
    btnTauStop.ParentDoubleBuffered := False;
    btnTauStop.DoubleBuffered := True;
    btnTauStop.Font.Charset := ANSI_CHARSET;
    btnTauStop.Font.Color := clWindowText;
    btnTauStop.Font.Height := -13;
    btnTauStop.Font.Name := 'Verdana';
    btnTauStop.Font.Style := [];
    btnTauStop.ParentColor := True;
    btnTauStop.TabOrder := 2;
    SetEvent(btnTauStop, Self, 'OnClick', 'TauMeldungClick');
    btnTauStop.Text := 'Stop';
    btnTauStop.BitmapContainer := BitmapCont;
    btnTauStop.ControlIndex := 0;
    lbBarcode.SetParentComponent(tabDaten);
    lbBarcode.Name := 'lbBarcode';
    lbBarcode.Left := 193;
    lbBarcode.Top := 20;
    lbBarcode.Width := 168;
    lbBarcode.Height := 61;
    lbBarcode.Cursor := crHandPoint;
    lbBarcode.HeightPercent := 100.000000000000000000;
    lbBarcode.WidthPercent := 100.000000000000000000;
    lbBarcode.ItemIndex := -1;
    btnBarcodeDel.SetParentComponent(tabDaten);
    btnBarcodeDel.Name := 'btnBarcodeDel';
    btnBarcodeDel.Left := 429;
    btnBarcodeDel.Top := 20;
    btnBarcodeDel.Width := 60;
    btnBarcodeDel.Height := 61;
    btnBarcodeDel.Cursor := crHandPoint;
    btnBarcodeDel.ParentDoubleBuffered := False;
    btnBarcodeDel.DoubleBuffered := True;
    btnBarcodeDel.Font.Charset := ANSI_CHARSET;
    btnBarcodeDel.Font.Color := clWindowText;
    btnBarcodeDel.Font.Height := -13;
    btnBarcodeDel.Font.Name := 'Verdana';
    btnBarcodeDel.Font.Style := [];
    btnBarcodeDel.ParentColor := True;
    btnBarcodeDel.TabOrder := 4;
    SetEvent(btnBarcodeDel, Self, 'OnClick', 'btnBarcodeDelClick');
    btnBarcodeDel.Text := '';
    btnBarcodeDel.TextVisible := False;
    btnBarcodeDel.Bitmaps.Clear;
    with btnBarcodeDel.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnBarcodeDel.BitmapVisible := True;
    btnBarcodeDel.BitmapContainer := BitmapCont;
    btnBarcodeDel.ControlIndex := 0;
    btnBarcodeIns.SetParentComponent(tabDaten);
    btnBarcodeIns.Name := 'btnBarcodeIns';
    btnBarcodeIns.Left := 367;
    btnBarcodeIns.Top := 20;
    btnBarcodeIns.Width := 60;
    btnBarcodeIns.Height := 61;
    btnBarcodeIns.Cursor := crHandPoint;
    btnBarcodeIns.ParentDoubleBuffered := False;
    btnBarcodeIns.DoubleBuffered := True;
    btnBarcodeIns.Font.Charset := DEFAULT_CHARSET;
    btnBarcodeIns.Font.Color := clWindowText;
    btnBarcodeIns.Font.Height := -11;
    btnBarcodeIns.Font.Name := 'Segoe UI';
    btnBarcodeIns.Font.Style := [];
    btnBarcodeIns.ParentColor := True;
    btnBarcodeIns.TabOrder := 5;
    SetEvent(btnBarcodeIns, Self, 'OnClick', 'btnBarcodeInsClick');
    btnBarcodeIns.Text := '';
    btnBarcodeIns.Bitmaps.Clear;
    with btnBarcodeIns.Bitmaps.Add do
    begin
      BitmapName := 'INS';
    end;
    btnBarcodeIns.BitmapVisible := True;
    btnBarcodeIns.BitmapContainer := BitmapCont;
    btnBarcodeIns.ControlIndex := 0;
    tabSprachDaten.Top := 56;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    lbBeladung.AfterLoadDFMValues;
    lbEntladung.AfterLoadDFMValues;
    edtTauRef.AfterLoadDFMValues;
    edtBeladung.AfterLoadDFMValues;
    edtEntladung.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    pgContr.AfterLoadDFMValues;
    tabEmpfang.AfterLoadDFMValues;
    sigCapt.AfterLoadDFMValues;
    btnSignaturSpeichern.AfterLoadDFMValues;
    mInfoSign.AfterLoadDFMValues;
    tabDoku.AfterLoadDFMValues;
    ImgContr.AfterLoadDFMValues;
    lbDokumentPos.AfterLoadDFMValues;
    fpFilePicker.AfterLoadDFMValues;
    cbxDokumente.AfterLoadDFMValues;
    btnDokumentDel.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnAkt.AfterLoadDFMValues;
    btnDownload.AfterLoadDFMValues;
    tabDaten.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    mDaten.AfterLoadDFMValues;
    btnTauStart.AfterLoadDFMValues;
    btnTauStop.AfterLoadDFMValues;
    lbBarcode.AfterLoadDFMValues;
    btnBarcodeDel.AfterLoadDFMValues;
    btnBarcodeIns.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
